import {
  CREATE_PERSON_ADDRESS,
  CREATE_PERSON_ADDRESS_ERROR,
  CREATE_PERSON_ADDRESS_SUCCESS,
  CREATE_PERSON_BACKUP_WITH_HOLDINGS,
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_ERROR,
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_SUCCESS,
  CREATE_PERSON_BIRTHDAY,
  CREATE_PERSON_BIRTHDAY_ERROR,
  CREATE_PERSON_BIRTHDAY_SUCCESS,
  CREATE_PERSON_COUNTRY,
  CREATE_PERSON_COUNTRY_ERROR,
  CREATE_PERSON_COUNTRY_SUCCESS,
  CREATE_PERSON_NAME,
  CREATE_PERSON_NAME_ERROR,
  CREATE_PERSON_NAME_SUCCESS,
  CREATE_PERSON_SSN,
  CREATE_PERSON_SSN_ERROR,
  CREATE_PERSON_SSN_SUCCESS,
  UPDATE_PERSON_ADDRESS,
  UPDATE_PERSON_ADDRESS_ERROR,
  UPDATE_PERSON_ADDRESS_SUCCESS,
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS,
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_ERROR,
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SUCCESS,
  UPDATE_PERSON_BIRTHDAY,
  UPDATE_PERSON_BIRTHDAY_ERROR,
  UPDATE_PERSON_BIRTHDAY_SUCCESS,
  UPDATE_PERSON_COUNTRY,
  UPDATE_PERSON_COUNTRY_ERROR,
  UPDATE_PERSON_COUNTRY_SUCCESS,
  UPDATE_PERSON_NAME,
  UPDATE_PERSON_NAME_ERROR,
  UPDATE_PERSON_NAME_SUCCESS,
  UPDATE_PERSON_SSN,
  UPDATE_PERSON_SSN_ERROR,
  UPDATE_PERSON_SSN_SUCCESS,
  CREATE_LEGAL_ENTITY_NAME,
  CREATE_LEGAL_ENTITY_NAME_SUCCESS,
  CREATE_LEGAL_ENTITY_NAME_ERROR,
  UPDATE_LEGAL_ENTITY_NAME,
  UPDATE_LEGAL_ENTITY_NAME_SUCCESS,
  UPDATE_LEGAL_ENTITY_NAME_ERROR,
  CREATE_LEGAL_ENTITY_EIN,
  CREATE_LEGAL_ENTITY_EIN_SUCCESS,
  CREATE_LEGAL_ENTITY_EIN_ERROR,
  UPDATE_LEGAL_ENTITY_EIN,
  UPDATE_LEGAL_ENTITY_EIN_SUCCESS,
  UPDATE_LEGAL_ENTITY_EIN_ERROR,
  CREATE_LEGAL_ENTITY_ADDRESS,
  CREATE_LEGAL_ENTITY_ADDRESS_SUCCESS,
  CREATE_LEGAL_ENTITY_ADDRESS_ERROR,
  UPDATE_LEGAL_ENTITY_ADDRESS,
  UPDATE_LEGAL_ENTITY_ADDRESS_SUCCESS,
  UPDATE_LEGAL_ENTITY_ADDRESS_ERROR,
  CREATE_PERSON_MARTIAL_STATUS,
  CREATE_PERSON_MARTIAL_STATUS_SUCCESS,
  CREATE_PERSON_MARTIAL_STATUS_ERROR,
  UPDATE_PERSON_MARTIAL_STATUS,
  UPDATE_PERSON_MARTIAL_STATUS_SUCCESS,
  UPDATE_PERSON_MARTIAL_STATUS_ERROR,
  CREATE_PERSON_PHONE,
  CREATE_PERSON_PHONE_SUCCESS,
  UPDATE_PERSON_PHONE,
  CREATE_PERSON_PHONE_ERROR,
  UPDATE_PERSON_PHONE_ERROR,
} from './personActionConstants';

export const createPersonName = (payload) => ({
  type: CREATE_PERSON_NAME,
  payload,
});

export const createPersonNameSuccess = (payload) => ({
  type: CREATE_PERSON_NAME_SUCCESS,
  payload,
});

export const createPersonNameError = (payload) => ({
  type: CREATE_PERSON_NAME_ERROR,
  payload,
});

export const updatePersonName = (payload) => ({
  type: UPDATE_PERSON_NAME,
  payload,
});

export const updatePersonNameSuccess = (payload) => ({
  type: UPDATE_PERSON_NAME_SUCCESS,
  payload,
});

export const updatePersonNameError = (payload) => ({
  type: UPDATE_PERSON_NAME_ERROR,
  payload,
});

export const createPersonSSN = (payload) => ({
  type: CREATE_PERSON_SSN,
  payload,
});

export const createPersonSSNSuccess = (payload) => ({
  type: CREATE_PERSON_SSN_SUCCESS,
  payload,
});

export const createPersonSSNError = (payload) => ({
  type: CREATE_PERSON_SSN_ERROR,
  payload,
});

export const updatePersonSSN = (payload) => ({
  type: UPDATE_PERSON_SSN,
  payload,
});

export const updatePersonSSNSuccess = (payload) => ({
  type: UPDATE_PERSON_SSN_SUCCESS,
  payload,
});

export const updatePersonSSNError = (payload) => ({
  type: UPDATE_PERSON_SSN_ERROR,
  payload,
});

export const createPersonAddress = (payload) => ({
  type: CREATE_PERSON_ADDRESS,
  payload,
});

export const createPersonAddressSuccess = (payload) => ({
  type: CREATE_PERSON_ADDRESS_SUCCESS,
  payload,
});

export const createPersonAddressError = (payload) => ({
  type: CREATE_PERSON_ADDRESS_ERROR,
  payload,
});

export const updatePersonAddress = (payload) => ({
  type: UPDATE_PERSON_ADDRESS,
  payload,
});

export const updatePersonAddressSuccess = (payload) => ({
  type: UPDATE_PERSON_ADDRESS_SUCCESS,
  payload,
});

export const updatePersonAddressError = (payload) => ({
  type: UPDATE_PERSON_ADDRESS_ERROR,
  payload,
});

export const createPersonBirthday = (payload) => ({
  type: CREATE_PERSON_BIRTHDAY,
  payload,
});

export const createPersonBirthdaySuccess = (payload) => ({
  type: CREATE_PERSON_BIRTHDAY_SUCCESS,
  payload,
});

export const createPersonBirthdayError = (payload) => ({
  type: CREATE_PERSON_BIRTHDAY_ERROR,
  payload,
});

export const updatePersonBirthday = (payload) => ({
  type: UPDATE_PERSON_BIRTHDAY,
  payload,
});

export const updatePersonBirthdaySuccess = (payload) => ({
  type: UPDATE_PERSON_BIRTHDAY_SUCCESS,
  payload,
});

export const updatePersonBirthdayError = (payload) => ({
  type: UPDATE_PERSON_BIRTHDAY_ERROR,
  payload,
});

export const createPersonPhone = (payload) => ({
  type: CREATE_PERSON_PHONE,
  payload,
});

export const createPersonPhoneSuccess = (payload) => ({
  type: CREATE_PERSON_PHONE_SUCCESS,
  payload,
});

export const createPersonPhoneError = (payload) => ({
  type: CREATE_PERSON_PHONE_ERROR,
  payload,
});

export const updatePersonPhone = (payload) => ({
  type: UPDATE_PERSON_PHONE,
  payload,
});

export const updatePersonPhoneSuccess = (payload) => ({
  type: UPDATE_PERSON_PHONE_ERROR,
  payload,
});

export const updatePersonPhoneError = (payload) => ({
  type: UPDATE_PERSON_COUNTRY_ERROR,
  payload,
});

export const createPersonCountry = (payload) => ({
  type: CREATE_PERSON_COUNTRY,
  payload,
});

export const createPersonCountrySuccess = (payload) => ({
  type: CREATE_PERSON_COUNTRY_SUCCESS,
  payload,
});

export const createPersonCountryError = (payload) => ({
  type: CREATE_PERSON_COUNTRY_ERROR,
  payload,
});

export const updatePersonCountry = (payload) => ({
  type: UPDATE_PERSON_COUNTRY,
  payload,
});

export const updatePersonCountrySuccess = (payload) => ({
  type: UPDATE_PERSON_COUNTRY_SUCCESS,
  payload,
});

export const updatePersonCountryError = (payload) => ({
  type: UPDATE_PERSON_COUNTRY_ERROR,
  payload,
});

export const createPersonIsBackupWithHoldings = (payload) => ({
  type: CREATE_PERSON_BACKUP_WITH_HOLDINGS,
  payload,
});

export const createPersonIsBackupWithHoldingsSuccess = (payload) => ({
  type: CREATE_PERSON_BACKUP_WITH_HOLDINGS_SUCCESS,
  payload,
});

export const createPersonIsBackupWithHoldingsError = (payload) => ({
  type: CREATE_PERSON_BACKUP_WITH_HOLDINGS_ERROR,
  payload,
});

export const updatePersonIsBackupWithHoldings = (payload) => ({
  type: UPDATE_PERSON_BACKUP_WITH_HOLDINGS,
  payload,
});

export const updatePersonIsBackupWithHoldingsSuccess = (payload) => ({
  type: UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SUCCESS,
  payload,
});

export const updatePersonIsBackupWithHoldingsError = (payload) => ({
  type: UPDATE_PERSON_BACKUP_WITH_HOLDINGS_ERROR,
  payload,
});

export const createLegalEntityName = (payload) => ({
  type: CREATE_LEGAL_ENTITY_NAME,
  payload,
});

export const createLegalEntityNameSuccess = (payload) => ({
  type: CREATE_LEGAL_ENTITY_NAME_SUCCESS,
  payload,
});

export const createLegalEntityNameError = (payload) => ({
  type: CREATE_LEGAL_ENTITY_NAME_ERROR,
  payload,
});

export const updateLegalEntityName = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_NAME,
  payload,
});

export const updateLegalEntityNameSuccess = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_NAME_SUCCESS,
  payload,
});

export const updateLegalEntityNameError = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_NAME_ERROR,
  payload,
});

export const createLegalEntityEin = (payload) => ({
  type: CREATE_LEGAL_ENTITY_EIN,
  payload,
});

export const createLegalEntityEinSuccess = (payload) => ({
  type: CREATE_LEGAL_ENTITY_EIN_SUCCESS,
  payload,
});

export const createLegalEntityEinError = (payload) => ({
  type: CREATE_LEGAL_ENTITY_EIN_ERROR,
  payload,
});

export const updateLegalEntityEin = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_EIN,
  payload,
});

export const updateLegalEntityEinSuccess = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_EIN_SUCCESS,
  payload,
});

export const updateLegalEntityEinError = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_EIN_ERROR,
  payload,
});

export const createLegalEntityAddress = (payload) => ({
  type: CREATE_LEGAL_ENTITY_ADDRESS,
  payload,
});

export const createLegalEntityAddressSuccess = (payload) => ({
  type: CREATE_LEGAL_ENTITY_ADDRESS_SUCCESS,
  payload,
});

export const createLegalEntityAddressError = (payload) => ({
  type: CREATE_LEGAL_ENTITY_ADDRESS_ERROR,
  payload,
});

export const updateLegalEntityAddress = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_ADDRESS,
  payload,
});

export const updateLegalEntityAddressSuccess = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_ADDRESS_SUCCESS,
  payload,
});

export const updateLegalEntityAddressError = (payload) => ({
  type: UPDATE_LEGAL_ENTITY_ADDRESS_ERROR,
  payload,
});

export const createPersonMartialStatus = (payload) => ({
  type: CREATE_PERSON_MARTIAL_STATUS,
  payload,
});

export const createPersonMartialStatusSuccess = (payload) => ({
  type: CREATE_PERSON_MARTIAL_STATUS_SUCCESS,
  payload,
});

export const createPersonMartialStatusError = (payload) => ({
  type: CREATE_PERSON_MARTIAL_STATUS_ERROR,
  payload,
});

export const updatePersonMartialStatus = (payload) => ({
  type: UPDATE_PERSON_MARTIAL_STATUS,
  payload,
});

export const updatePersonMartialStatusSuccess = (payload) => ({
  type: UPDATE_PERSON_MARTIAL_STATUS_SUCCESS,
  payload,
});

export const updatePersonMartialStatusError = (payload) => ({
  type: UPDATE_PERSON_MARTIAL_STATUS_ERROR,
  payload,
});
